module.exports = __webpack_public_path__ + "img/r-26.0a399e54.jpg";